import { gql } from "apollo-boost";

const queryCompanies = gql`
  query companies($limit: Int!, $offset: Int!) {
    companies(filter: {
      limit: $limit,
      offset: $offset
    }) {
      edges {
        node {
          integrations {
            moneris
            monerisTest
            stripe
            stripeTest
            stripePublishableKey
          }
        }
      },
      totalCount
    }
  }
`;

export {
  queryCompanies
};
